import { render, staticRenderFns } from "./UpdateInforSimCard.vue?vue&type=template&id=529d609c"
import script from "./UpdateInforSimCard.vue?vue&type=script&lang=js"
export * from "./UpdateInforSimCard.vue?vue&type=script&lang=js"
import style0 from "./UpdateInforSimCard.vue?vue&type=style&index=0&id=529d609c&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports